import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    template: String,
  };

  static targets = ["outlet"];

  connect() {
    this.translate = this.translate.bind(this);
    this.element.addEventListener("i18n:translate", this.translate);
  }

  disconnect() {
    this.element.removeEventListener("i18n:translate", this.translate);
  }

  translate(e) {
    const { params } = e.detail;
    let value = this.templateValue;

    for (const key in params) {
      value = value.replace(`%{${key}}`, params[key]);
    }

    this.outlet.innerHTML = value;
  }

  get outlet() {
    if (this.hasOutletTarget) {
      return this.outletTarget;
    }

    return this.element;
  }
}
